import axios from "axios";
import handlerError from "@/utils/handlerError";
import store from "@/store";
import QueryString from "qs";
import { interceptorsError } from "@/api/interceptors";
import router from "@/router";

// const syncLogout = (event) => {
//     if (event.key === "logout") {
//         console.log("logged out from storage!");
//         router.push("/login");
//     }
// };
// window.addEventListener("storage", syncLogout);

window.addEventListener("storage", (event) => {
    console.log(event);
    if (event.key === "logout") {
        router.push("/login");
    }
    // When local storage changes, dump the list to
    // the console.
    // console.log(JSON.parse(window.localStorage.getItem("logout")));
});

// nginx in production and the dev-server proxy both serve API on the same origin.
export const baseURL = () => "/api";
axios.defaults.withCredentials = true;
export const api = axios.create({
    whitCredentials: true,
    baseURL: baseURL(),
    header: {
        "Content-Type": "application/json",
    },
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return interceptorsError(error);
    }
);
/**
 * обработчик полученного ответа с сервера, смотрит статус ответа и в зависимости от него выводит сообщение об ошибке/предупреждении/выполнении
 * @param url - адрес запроса
 * @param data - данные, которые пришли с сервера
 * @returns {*} возвращает данные пришедшие с сервера, либо ошибку
 */
const handlerResponse = (url, data) => {
    const { msg_type, msg } = data;

    if (handlerError.isError(msg_type)) {
        if (msg && msg.response?.status !== 401) {
            store.commit("general/SET_MESSAGE_VIEW", {
                message: msg,
                type: `error`,
            });
        }
        throw "api_error";
    } else if (handlerError.isWarning(msg_type)) {
        if (msg && msg.response?.status !== 401) {
            store.commit("general/SET_MESSAGE_VIEW", {
                message: msg,
                type: `warn`,
            });
        }
        return data;
    } else {
        return data;
    }
};
/**
 * выводит сообщение об ошибке запроса, для 401 - мягкое уведомление о повторном входе
 * @param error - объект ошибки axios
 */
const showRequestError = (error) => {
    if (error?.response?.status === 401) {
        store.commit("general/SET_MESSAGE_VIEW", {
            message: "Сессия истекла. Повторите вход",
            type: "info",
        });
    } else {
        store.commit("general/SET_MESSAGE_VIEW", {
            message: `${error.message}`,
            type: `error`,
        });
    }
};
const authHeader = () => {
    // let user = JSON.parse(localStorage.getItem('user'));
    let jwt = store.getters["user/jwt"];

    if (jwt && jwt.jwt_token) {
        return { Authorization: "Bearer " + jwt.jwt_token };
    } else {
        return {};
    }
};
/**
 * отправляет запрос на сервер через метод GET
 * @param url - адрес запроса
 * @param params - передаваемы на сервер параметры
 * @returns {Promise<*>}
 */
export const sendGet = async (url, params = {}) => {
    try {
        const response = await api.get(
            `${url}`,
            { params, headers: authHeader() },
            {
                whitCredentials: true,
            }
        );
        return handlerResponse(url, response.data);
    } catch (error) {
        if (error !== "api_error" && error !== "network") {
            showRequestError(error);
        }
        throw "network";
    }
};
/**
 * отправляет запрос на сервер через метод POST
 * @param url - адрес запроса
 * @param params - передаваемы на сервер параметры
 * @param config - конфигурации для отправления на сервер
 * @returns {Promise<*>}
 */
export const sendPost = async (url, params = {}, config = {}) => {
    try {
        const response = await api.post(`${url}`, params, {
            ...config,
            headers: authHeader(),
        });
        return handlerResponse(url, response.data);
    } catch (error) {
        if (error !== "api_error" && error !== "network") {
            showRequestError(error);
        }
        throw "network";
    }
};
/**
 * отправляет запрос на сервер через метод PUT
 * @param url - адрес запроса
 * @param params - передаваемы на сервер параметры
 * @returns {Promise<*>}
 */
export const sendPut = async (url, params = {}) => {
    try {
        const response = await api.put(`${url}`, params, {
            headers: authHeader(),
        });
        return handlerResponse(url, response.data);
    } catch (error) {
        if (error !== "api_error" && error !== "network") {
            showRequestError(error);
        }
        throw "network";
    }
};
/**
 * отправляет запрос на сервер через метод DELETE
 * @param url - адрес запроса
 * @param params - передаваемы на сервер параметры
 * @returns {Promise<*>}
 */
export const sendDelete = async (url, params = {}) => {
    try {
        const response = await api.delete(`${url}`, {
            data: params,
            headers: authHeader(),
        });
        return handlerResponse(url, response.data);
    } catch (error) {
        if (error !== "api_error" && error !== "network") {
            showRequestError(error);
        }
        throw "network";
    }
};

export const sendGetDownload = async (url, fileName, type_file, params) => {
    try {
        const response = await api.get(`${url}`, {
            responseType: "blob",
            headers: authHeader(),
            paramsSerializer: (params) => {
                return QueryString.stringify(params, {
                    arrayFormat: "repeat",
                });
            },
            params,
        });

        if (response.data.size === 0) {
            throw "error";
        } else {
            const url2 = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url2;
            link.setAttribute(
                "download",
                `${fileName}.${type_file ? type_file : "xlsx"}`
            );
            document.body.appendChild(link);
            link.click();
        }
    } catch (error) {
        const { msg_type, msg } = error;
        if (msg && msg.response?.status !== 401) {
            store.commit("general/SET_MESSAGE_VIEW", {
                message: `${msg}`,
                type: `${msg_type}`,
            });
        }
        throw "network";
    }
};
